import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Link, Typography, Stack, Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
// routes
import { PATH_AUTH } from '../../routes/paths';
// layouts
import AuthLayout from '../../layouts/AuthLayout';
// components
import Page from '../../components/Page';
import useAuth from '../../hooks/useAuth';
// sections
// sections
import { LoginForm } from '../../sections/auth/login';
import { APP_NAME } from '../../config';

// ----------------------------------------------------------------------

export default function Login() {
  const { setting } = useAuth();
  const appName = setting?.general?.app_name || APP_NAME;

  return (
    <Page title="Login">
      <AuthLayout>
        <Stack spacing={1} sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h4" sx={{ fontWeight: 800 }}>
            Welcome Back
          </Typography>
          <Typography sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
            Sign in to your account and have a blast!
          </Typography>
        </Stack>

        <Box sx={{ 
          display: 'flex', 
          p: 0.5, 
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.05),
          borderRadius: 2,
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          mb: 4
        }}>
           <Box sx={{ 
             flex: 1, 
             textAlign: 'center', 
             py: 1.5, 
             bgcolor: 'primary.main', 
             color: 'white', 
             borderRadius: 1.5,
             fontWeight: 700,
             cursor: 'pointer'
           }}>
             Sign In
           </Box>
           <Box 
             component={RouterLink}
             to={PATH_AUTH.register}
             sx={{ 
                flex: 1, 
                textAlign: 'center', 
                py: 1.5, 
                color: 'primary.main', 
                borderRadius: 1.5,
                fontWeight: 700,
                textDecoration: 'none',
                cursor: 'pointer'
             }}
           >
             Create An Account
           </Box>
        </Box>

        <LoginForm />

      </AuthLayout>
    </Page>
  );
}
